<template>
  <v-app-bar
    id="main-toolbar"
    color="#F3F3F0"
    fixed
    app
    clipped-right
    :height="$vuetify.breakpoint.smAndDown ? 108 : 64"
    :prominent="$vuetify.breakpoint.smAndDown"
  >
    <v-toolbar-title>

      <router-link to="/home" class="home-link">
        <img src="/img/epd-logo-regular.svg" class="epd-logo">
      </router-link>

      <div class="search">
        <v-btn tile depressed color="secondary" class="state-select" @click="toggleSearch">
          <v-icon>menu</v-icon>
        </v-btn>
        <v-text-field
          name="searchquery"
          id="searchquery"
          v-model="searchquery"
          placeholder="Suche..."
          hide-details
          single-line
          outlined
          light
          dense
          :autocomplete="false"
          @keyup.enter="triggerSearch"
        ></v-text-field>
        <v-btn tile depressed color="secondary" class="state-select" @click="triggerSearch">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </div>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <div v-if="userAuthenticated">
      <span class="name" v-if="$vuetify.breakpoint.smAndUp && !isNumericUser">
        {{ username }}
      </span>
      <v-menu
        transition="slide-y-transition"
        bottom
        v-if="!isNumericUser"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            v-on="on"
          >
            <v-icon>person</v-icon>
          </v-btn>
        </template>
        <v-list min-width="160" max-width="260">
          <div class="name pl-3 text-truncate" v-if="$vuetify.breakpoint.xsOnly">
            <v-icon>person</v-icon>
            {{ username }}
          </div>
          <v-subheader>MENU</v-subheader>
          <v-list-item
            v-for="(item, i) in optionsMenu"
            :key="i"
            @click="onMenuClick(item.action)"
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <div v-else>
      <LoginView/>
    </div>

    <HelpModal v-if="$vuetify.breakpoint.smAndUp"/>
    <v-tooltip bottom class="tooltip">
      <template v-slot:activator="{ on }">
        <v-btn class="mr-1" icon color="primary" v-on="on" href="https://www.epd.de/impressum">§</v-btn>
      </template>
      <span>Impressum</span>
    </v-tooltip>

  </v-app-bar>
</template>

<script>
import { setTimeout } from 'timers';
import { mapState } from 'vuex';
import LoginView from '@/components/LoginView.vue'; // @ is an alias to /src
import HelpModal from '@/components/HelpModal.vue';

export default {
  data() {
    return {
      help: false,
      listIcons: true,
      editIcons: false,
      aboutIcons: false,
      option: null,
      optionsMenu: [
        { title: 'Einstellungen', action: 'goToSettings' },
        { title: 'Abmelden', action: 'userLogout' },
      ],
    };
  },
  methods: {
    checkUser() {
      if (!this.option) {
        this.option = this.optionsMenu.find((item) => item.action === 'userLogout');
      }
    },
    triggerSearch() {
      this.$store.dispatch('performSearch', 'toolbar');
    },
    toggleSearch() {
      this.$store.commit('toggleSearchModal', true);
    },
    onMenuClick(action) {
      if (action === 'userLogout') {
        // log out user and forward to login page
        this.$store.commit('setUserAuthenticated', false);
        this.$store.commit('updateSearchparameters', {key: 'searchString', val: ''});
        this.$router.push('/');
      } else if (action === 'goToSettings') {
        // go to settings page
        this.$router.push('/settings');
      }
    },
  },
  computed: {
    userAuthenticated() {
      const isAuthenticated =  this.$store.state.app.userAuthenticated;
      if (isAuthenticated === true) {
        this.checkUser();
      }
      return isAuthenticated;
    },
    username() {
      return this.$store.state.app.username;
    },
    isNumericUser() {
      return this.username.match(/auth\d+/);
    },
    searchquery: {
      get() {
        return this.$store.state.list.filters.searchString;
      },
      set(val) {
        this.$store.commit('updateSearchparameters', {
          key: 'searchString',
          val: val.replace(/[|&;!$%@/<>()+]/g, ''),
        });
      },
    },
  },
  watch: {
    $route(to, from) {
      this.listIcons = false;
      this.editIcons = false;
      this.aboutIcons = false;
      if (to.name === 'home' || to.name === 'list') {
        this.listIcons = true;
      } else if (to.name === 'edit') {
        this.editIcons = true;
      } else {
        this.aboutIcons = true;
      }
    },
  },
  components: {
    LoginView,
    HelpModal,
  },
};
</script>

<style lang="less">
  .home-link {
    text-decoration: none;
  }
  .epd-logo {
    margin: 0px 0 -23px 0;
    position: absolute;
    left: 10px;
    top: 12px;
    width: 310px;
  }
  @media screen and (min-width: 600px) {
    .epd-logo {
      width: 385px;
    }
  }
  .search {
    position: absolute;
    top: 45px;
    left: 53%;
    transform: translateX(-50%);
    padding: 12px 0;
    box-shadow: 0 2px 3px -1px rgba(0, 0, 0, 0.2);
    padding: 0;
    .v-btn {
      margin: 0;
    }
    .v-input {
      // TODO: mobile <-> desktop
      display: inline-block;
      border-radius: 0;
      width: calc(100vw - 820px);
      background-color: white;
    }
  }
  @media screen and (max-width: 959px) {
    .search {
      z-index: 2;
      top: 49px;
      left: 10px;
      margin: 0;
      transform: translateX(0);
      width: 100%;
      .v-input {
        // TODO: mobile <-> desktop
        width: calc(100vw - 100px);
      }
    }
  }
  button.v-btn.state-select {
    padding: 0 !important;
    min-width: unset !important;
    width: 40px !important;
    height: 40px !important;

    &.state-inactive {
      opacity: .6;
    }
  }
  .settings-menu {
    .v-radio {
      margin-right: 0;
    }
    .v-messages {
      display: none;
    }
    .v-input__control {
      width: 100%;
      .v-input__slot {
        margin-bottom: 0;
        width: 100%;
      }
    }
  }
  .v-toolbar__content, .v-toolbar__extension {
    padding-right: 10px;
  }
  .tootltip {
    right: 5px;
  }
</style>
